export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img3-bf9b9733af4c7521b0e8c5f967642dfc.png";